export default __webpack_public_path__ + "static/media/preincipiones.5db5a001.svg";